var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40708 1.89394C3.39683 2.18148 1.85153 3.91032 1.85153 6.00008C1.85153 8.29104 3.70872 10.1482 5.99967 10.1482C8.29063 10.1482 10.1478 8.29104 10.1478 6.00008C10.1478 4.79214 9.63151 3.70479 8.80753 2.94668L9.64615 2.10806C10.6843 3.08115 11.333 4.46486 11.333 6.00008C11.333 8.9456 8.94519 11.3334 5.99967 11.3334C3.05416 11.3334 0.666342 8.9456 0.666342 6.00008C0.666342 3.05456 3.05416 0.666748 5.99967 0.666748C6.19998 0.666748 6.3977 0.67779 6.59227 0.699298V4.27298H5.40708V1.89394Z",
    fill: "#027EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54361 4.04872C8.77503 4.28014 8.77503 4.65535 8.54361 4.88677L6.86751 6.56288C6.63609 6.7943 6.26088 6.7943 6.02945 6.56288C5.79803 6.33146 5.79803 5.95625 6.02945 5.72482L7.70556 4.04872C7.93698 3.8173 8.31219 3.8173 8.54361 4.04872Z",
    fill: "#027EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.ed8799481e864a73c1aa94d9aeff7701.svg";
export { ForwardRef as ReactComponent };